import { ROUTES } from '~shared/config/routes';

import { isNewUser } from './permission-checks';

import type { Permission } from '../entities/permissions';

export const getDefaultRouteByPermissions = (permissions: Permission[]) => {
  if (isNewUser(permissions)) {
    return ROUTES.partner.root;
  }

  if (permissions.includes('DASHBOARD_VIEW')) {
    return ROUTES.dashboard;
  }

  if (permissions.includes('APPLICATIONS_VIEW')) {
    return ROUTES.transactions.loans;
  }

  if (permissions.includes('TRANSACTIONS_VIEW')) {
    return ROUTES.transactions.payments;
  }

  if (permissions.includes('ORDERS_VIEW')) {
    return ROUTES.orders.root;
  }

  if (permissions.includes('ORDERS_CREATE')) {
    return ROUTES.orders.create;
  }

  if (permissions.includes('PROFILE_VIEW')) {
    return ROUTES.profile;
  }

  return ROUTES.accessDenied;
};
